import DOMPurify from 'dompurify'

// Force any anchor that opens a new tab to also drop the opener/referrer, so
// sanitized (analyst-authored) HTML can't be used for reverse tabnabbing.
// Registered once at module load; DOMPurify hooks are global and idempotent.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

/**
 * Sanitize untrusted/backend HTML for use with `dangerouslySetInnerHTML`.
 * Uses DOMPurify defaults (strips scripts + event handlers) and, via the hook
 * above, hardens any `target="_blank"` links with `rel="noopener noreferrer"`.
 * Use this instead of calling `DOMPurify.sanitize` directly so the tabnabbing
 * hardening is applied consistently.
 */
export const sanitizeHtml = (dirty: string): string => DOMPurify.sanitize(dirty)

/**
 * Check if two DOM element layouts overlap
 */
export const elementsOverlap = (el1: Element, el2: Element) => {
  const domRect1 = el1.getBoundingClientRect()
  const domRect2 = el2.getBoundingClientRect()

  return !(domRect1.top > domRect2.bottom || domRect1.right < domRect2.left || domRect1.bottom < domRect2.top || domRect1.left > domRect2.right)
}

export const htmlDecode = (text: string, mime: DOMParserSupportedType = 'text/html') => {
  const decoded = new DOMParser().parseFromString(text, mime)
  return decoded.documentElement.textContent
}
